
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PlusCircle, FileText, Clock } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const BartenderReportsPage = () => {
  const mockReports = [
    { id: 1, date: "2023-11-10", venue: "Club Neon", type: "End of Shift", status: "Submitted" },
    { id: 2, date: "2023-11-05", venue: "Skyline Lounge", type: "Inventory", status: "Pending" },
    { id: 3, date: "2023-10-29", venue: "The Basement", type: "End of Shift", status: "Approved" },
  ];

  return (
    <div className="container mx-auto p-6 max-w-6xl">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Bar Reports</h1>
        <Button>
          <PlusCircle className="mr-2 h-4 w-4" />
          New Report
        </Button>
      </div>

      <Tabs defaultValue="all">
        <div className="border-b mb-4">
          <TabsList className="w-full justify-start">
            <TabsTrigger value="all">All Reports</TabsTrigger>
            <TabsTrigger value="shift">End of Shift</TabsTrigger>
            <TabsTrigger value="inventory">Inventory</TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="all" className="space-y-6">
          <Card>
            <CardContent className="pt-6">
              <div className="space-y-4">
                {mockReports.map((report) => (
                  <div key={report.id} className="flex items-center justify-between p-4 border rounded-lg">
                    <div className="flex items-center gap-4">
                      {report.type === "End of Shift" ? (
                        <Clock className="h-6 w-6 text-purple-500" />
                      ) : (
                        <FileText className="h-6 w-6 text-blue-500" />
                      )}
                      <div>
                        <h3 className="font-semibold">{report.type} Report - {report.venue}</h3>
                        <p className="text-sm text-muted-foreground">Date: {report.date}</p>
                        <span className={`text-xs px-2 py-1 rounded-full ${
                          report.status === "Approved" ? "bg-green-100 text-green-800" :
                          report.status === "Pending" ? "bg-amber-100 text-amber-800" :
                          "bg-blue-100 text-blue-800"
                        }`}>
                          {report.status}
                        </span>
                      </div>
                    </div>
                    <Button variant="outline" size="sm">View Report</Button>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="shift" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>End of Shift Reports</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {mockReports.filter(r => r.type === "End of Shift").map((report) => (
                  <div key={report.id} className="flex items-center justify-between p-4 border rounded-lg">
                    <div className="flex items-center gap-4">
                      <Clock className="h-6 w-6 text-purple-500" />
                      <div>
                        <h3 className="font-semibold">End of Shift Report - {report.venue}</h3>
                        <p className="text-sm text-muted-foreground">Date: {report.date}</p>
                        <span className={`text-xs px-2 py-1 rounded-full ${
                          report.status === "Approved" ? "bg-green-100 text-green-800" :
                          "bg-blue-100 text-blue-800"
                        }`}>
                          {report.status}
                        </span>
                      </div>
                    </div>
                    <Button variant="outline" size="sm">View Report</Button>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="inventory" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Inventory Reports</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {mockReports.filter(r => r.type === "Inventory").map((report) => (
                  <div key={report.id} className="flex items-center justify-between p-4 border rounded-lg">
                    <div className="flex items-center gap-4">
                      <FileText className="h-6 w-6 text-blue-500" />
                      <div>
                        <h3 className="font-semibold">Inventory Report - {report.venue}</h3>
                        <p className="text-sm text-muted-foreground">Date: {report.date}</p>
                        <span className="text-xs px-2 py-1 rounded-full bg-amber-100 text-amber-800">
                          {report.status}
                        </span>
                      </div>
                    </div>
                    <Button variant="outline" size="sm">View Report</Button>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};
